"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".callout_a3cb6007 .ms-Suggestions-itemButton{padding:0px;border:none}.callout_a3cb6007 .ms-Suggestions{width:300px}\n" }]);
exports.callout = "callout_a3cb6007";
//# sourceMappingURL=BaseFloatingPicker.scss.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/components/FloatingPicker/BaseFloatingPicker.scss.js
// module id = 1550
// module chunks = 0